import React from 'react'
import BaseInputs from './baseInputs'
import DateValidInputs from './dateValidInputs'
import CheckBox from '@/components/CheckBox'
import Resx from '@/components/Resx'

export default class HasRequiredValidToItemForm extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      id: props.item ? props.item.id : undefined,
      name: props.item ? props.item.name : '',
      latinName: props.item ? props.item.latinName : '',
      code: props.item ? props.item.code : '',
      legacyCode: props.item ? props.item.legacyCode : '',
      validFrom: props.item ? props.item.validFrom : null,
      validTo: props.item ? props.item.validTo : null,
      hasValidToRequired: props.item ? props.item.hasValidToRequired : false
    }
  }

  onInputChange (values) {
    this.setState({ ...values },
      () => this.onChange())
  }

  onChange () {
    this.props.onChange({
      id: this.state.id,
      name: this.state.name,
      latinName: this.state.latinName,
      code: this.state.code,
      legacyCode: this.state.legacyCode,
      validFrom: this.state.validFrom,
      validTo: this.state.validTo,
      hasValidToRequired: this.state.hasValidToRequired
    })
  }

  render () {
    const { isReadOnly } = this.props

    return (
      <div>
        <BaseInputs name={this.state.name} latinName={this.state.latinName} code={this.state.code} legacyCode={this.state.legacyCode} isReadOnly={isReadOnly}
          onChange={(values) => this.onInputChange(values)} />
        <DateValidInputs validFrom={this.state.validFrom} validTo={this.state.validTo} isReadOnly={isReadOnly}
          onChange={(values) => this.onInputChange(values)} />
        <CheckBox id='hasValidToRequired' checked={this.state.hasValidToRequired} onChange={value => this.onInputChange({ hasValidToRequired: value })} label={<Resx name='Common.HasValidToRequired' />} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/codeLists/hasRequiredValidToItemForm.js